import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { Grid, withStyles } from '@material-ui/core';
import LibrarySectionList from '../LibrarySectionList'
import Person from './Person'
import { chunk } from '../../../../../utils/commonHelpers';
import { showSnackbar } from '../../../../../actions/appActions';
import { librarySections } from '../../../../../utils/library/librarySections';
import NoItemsPlaceholder from '../NoItemsPlaceholder/NoItemsPlaceholder';

const HEIGHT_NO_ITEMS = 150
const HEIGHT_CONTAINER = 445

const styles = theme => ({
    peopleContainer: {
        height: HEIGHT_CONTAINER,
        width: 1286,
        backgroundColor: '#f5f5f5',
        marginTop: 48,
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    headerSection: {
        height: 70,
        display: 'flex',
        flexDirection: 'row',
    },
    titles: {
        flexDirection: 'column',
        marginRight: 'auto'
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 32,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#21212d',
    },
    subtitle: {
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.75,
        letterSpacing: 'normal',
        color: '#a3a3a3',
    },
    controlButtons: {
        flexDirection: 'column',
        alignSelf: 'center',
        border: 'solid 2px #e0e0e0',
        borderRadius: 4,
        width: 84,
        height: 38,
    },
    people: {
        marginTop: (46 + 14) * -1,
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto auto auto'
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: theme.newUI.color.commonBlack
    },
    leftButton: {
        width: 42,
        height: 38,
        background: 'none',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        background: 'none',
        border: 'none',
        borderLeft: 'solid 0.5px #e0e0e0',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    controlWrap: {
        width: 1286,
        top: 0,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    listContainer: {
        width: 1286,
        height: 445,
        alignItems: 'end'
    },
    cardsContainer: {
        position: 'absolute',
        top: 60,
    },
});
const tuqqiPeopleColors = ['#3b61a1', '#904290', '#992b43', '#272c33', '#e08d1e', '#221f2b']

const SCREEN_ITEMS = 6
const mapPeople = (users) => {
    const sortedUsers = users.sort((a, b) => b.points - a.points)
     const people = sortedUsers.map((user, i) => ({
         title: `${user.firstname} ${user.lastname}`,
         subtitle: user.title,
         tag: user.tag,
         meta: user,
         backgroundImage: user.profileImageUrl.replace('fit-in/50x0', 'fit-in/200x0')
     }))
    const chunks = chunk(SCREEN_ITEMS, people)
    return chunks.reduce((accum, chunk) => [...accum, ...chunk.map((person, i) => ({...person, backgroundColor: tuqqiPeopleColors[i]}))], [])
}

const People = (props) => {
    const {classes, users} = props

    const [people, setPeople] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setPeople(mapPeople(users))
    }, [users])

    const Header = (
        <div data-intrcm-id="People_4iq32dq0" className={classes.title}>{librarySections().people.title}</div>
    )
    const SubHeader = (
        <div data-intrcm-id="People_j5o63qeu" className={classes.subtitle}>{librarySections().people.subtitle}</div>
    )

    const subscribe = (tagInfo, goToUser) => {
        if(isLoading) return
        const { userSettingsService, dispatch } = props;
        setIsLoading(true)
        dispatch(showSnackbar('subscribing...'));
        userSettingsService
            .subscribe(tagInfo)
            .then((_) => {
                userSettingsService.getUserData().then((userData) => {
                    dispatch(showSnackbar('Subscribed successfully!'));
                    dispatch({
                        type: 'USER_DATA_LOAD', data: {
                            ...userData
                        }
                    });
                    setIsLoading(false)
                    goToUser()
                })
            });
    }

    const controlStyles = {
        controlWrap: classes.controlWrap,
        controlButtons: classes.controlButtons,
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        activeIcon: classes.activeIcon,
        disableIcon: classes.disableIcon,
        arrowBg: 'transparent'
    }

        return (
            <div data-intrcm-id="People_muhhuxme" style={{height: people.length === 0 ? HEIGHT_NO_ITEMS : HEIGHT_CONTAINER}} className={classes.peopleContainer}>
                <Grid>
                    <div data-intrcm-id="People_bzaeiyxt" className={classes.headerSection} >
                        <div data-intrcm-id="People_8efnu64h" className={classes.titles}>
                            {Header}
                            {SubHeader}
                        </div>
                    </div>
                    {people.length === 0 &&
                        <NoItemsPlaceholder placeholder={"No employees available"} />
                    }
                    <div data-intrcm-id="People_yd928w4u" className={classes.people}>
                        {people.length > 0 &&
                            <LibrarySectionList screenSize={SCREEN_ITEMS} listContainerStyle={classes.listContainer} cardsContainerStyle={classes.cardsContainer} controlStyles={controlStyles} >
                                {people.map((person, i) => (
                                    <Person key={i} person={person} subscribe={subscribe} />
                                ))}
                            </LibrarySectionList>
                        }
                    </div>
                </Grid>
            </div>
        )
}

const mapStateToProps = (state) => ({
    users: state.globalData.users,
    userSettingsService: state.services.userSettingsService,
    userData: state.userData,
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(People);